import { render, staticRenderFns } from "./BpbjStandardQtTable.vue?vue&type=template&id=64623b68&scoped=true&"
import script from "./BpbjStandardQtTable.vue?vue&type=script&lang=js&"
export * from "./BpbjStandardQtTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64623b68",
  null
  
)

export default component.exports